// extracted by mini-css-extract-plugin
module.exports = {"button1":"ButtonGreen_button1__358Kz","icon":"ButtonGreen_icon__hKKsd","level":"ButtonGreen_level__nkU-s","body":"ButtonGreen_body__2FWks"};